import {useState} from 'react';
import {t} from 'i18next';
import {DisplayMessage} from '../lib/interfaces';
import {useUserClaims} from '../hooks/useUserClaims';
import {UPPSALA_KOMMUN_PHONE_NUMBER, pinUserClaim} from '../utils/constants';
import {Trans} from 'react-i18next';
import {cancelBooking} from '../services/bookingServices';
import {DisplayMessageTypes} from '../lib/enums';
import {UaButton, UaDialog} from 'uppsala.ui.react';

interface CancelBookingButtonProps {
  bookingId: string;
  setDisplayMessage: (message: DisplayMessage, bookingId: string) => void;
  onClick: () => void;
}

const CancelBookingButton = (props: CancelBookingButtonProps) => {
  const {userClaims} = useUserClaims();
  const [showCancelBookingWarning, setShowCancelBookingWarning] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleCancelBooking = async () => {
    if (props.bookingId.length === 0 || isLoading) return;
    setIsLoading(true);

    const result = await cancelBooking(props.bookingId, userClaims?.[pinUserClaim] ?? '');

    if (result.data && result.info) {
      props.setDisplayMessage(result.info, props.bookingId);
    } else {
      props.setDisplayMessage(
        {
          visible: true,
          type: DisplayMessageTypes.Warning,
          message: (
            <p className="whitespace-pre-line">
              <Trans
                i18nKey={'message.bookingCouldNotBeDeleted' as string}
                values={{number: UPPSALA_KOMMUN_PHONE_NUMBER}}
                components={{
                  1: <a href={`tel:${UPPSALA_KOMMUN_PHONE_NUMBER}`} aria-label="Telefonnummer" />,
                }}
              />
            </p>
          ),
        } as DisplayMessage,
        props.bookingId
      );
    }

    setIsLoading(false);
    setShowCancelBookingWarning(false);
  };

  return (
    <div>
      <UaButton
        type="danger"
        title={t('button.cancelBooking')}
        onClick={() => {
          setShowCancelBookingWarning(!showCancelBookingWarning);
          props.onClick();
        }}
      />

      <UaDialog
        visible={showCancelBookingWarning}
        title={t('message.deleteConfirmBooking')}
        cancelText={t('button.cancel')}
        onCancel={() => setShowCancelBookingWarning(false)}
        okText={t('button.cancelBooking')}
        onOk={handleCancelBooking}
      />
    </div>
  );
};

export default CancelBookingButton;
